import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'vehicles';
const BASE_PATH = `${API_ROOT}/vehicles`;
const PATHS = {
    COMMAND: (vehicleId) => `${BASE_PATH}/${vehicleId}/command`,
    CONFIRM_ACTIVATION: (vehicleId) => `${BASE_PATH}/${vehicleId}/activate`,
    CREATE: BASE_PATH,
    DEACTIVATE: (vehicleId) => `${BASE_PATH}/${vehicleId}/deactivate`,
    DELETE: (vehicleId) => `${BASE_PATH}/${vehicleId}`,
    GET: (vehicleId) => `${BASE_PATH}/${vehicleId}`,
    GET_LAST_METRICS: (vehicleId) => `${BASE_PATH}/${vehicleId}/last_metrics`,
    GET_LAST_GEOMETRICS: (vehicleId) => `${BASE_PATH}/${vehicleId}/last_geometrics`,
    GET_REALTIME_GEOMETRICS: (vehicleId) => `${BASE_PATH}/${vehicleId}/realtime_geometrics`,
    GET_REALTIME_METRICS: (vehicleId) => `${BASE_PATH}/${vehicleId}/realtime_metrics`,
    GET_SESSIONS: (vehicleId) => `${BASE_PATH}/${vehicleId}/sessions`,
    LIST: BASE_PATH,
    UPDATE: (vehicleId) => `${BASE_PATH}/${vehicleId}`,
};
async function command(csrfToken, vehicleId, operatorId, command, props) {
    return (await (await SecureAxios()).post(PATHS.COMMAND(vehicleId), { operatorId, command, ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function confirmActivation(csrfToken, vehicleId, token) {
    return (await (await SecureAxios()).post(PATHS.CONFIRM_ACTIVATION(vehicleId), { token }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function create(csrfToken, props) {
    const form = new FormData();
    form.append('vehicleType', props.vehicleType);
    form.append('name', props.name);
    form.append('serialNumber', props.serialNumber);
    form.append('email', props.email);
    return (await (await SecureAxios()).post(PATHS.CREATE, form, {
        headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' },
    })).data;
}
async function deactivate(csrfToken, vehicleId) {
    return (await (await SecureAxios()).post(PATHS.DEACTIVATE(vehicleId), {}, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
async function delete_(csrfToken, vehicleId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(vehicleId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(vehicleId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(vehicleId)}?${params.toString()}`)).data;
}
function getKey(vehicleId, props) {
    return [CacheKey, 'get', vehicleId, props];
}
async function getLastGeometrics(vehicleId) {
    return (await (await SecureAxios()).get(PATHS.GET_LAST_GEOMETRICS(vehicleId))).data;
}
function getLastGeometricsKey(vehicleId) {
    return [CacheKey, 'getLastGeometrics', vehicleId];
}
async function getLastMetrics(vehicleId) {
    return (await (await SecureAxios()).get(PATHS.GET_LAST_METRICS(vehicleId))).data;
}
function getLastMetricsKey(vehicleId) {
    return [CacheKey, 'getLastMetrics', vehicleId];
}
async function getRealtimeGeometrics(vehicleId) {
    return (await (await SecureAxios()).get(PATHS.GET_REALTIME_GEOMETRICS(vehicleId))).data;
}
function getRealtimeGeometricsKey(vehicleId) {
    return [CacheKey, 'getRealtimeGeometrics', vehicleId];
}
async function getRealtimeMetrics(vehicleId) {
    return (await (await SecureAxios()).get(PATHS.GET_REALTIME_METRICS(vehicleId))).data;
}
function getRealtimeMetricsKey(vehicleId) {
    return [CacheKey, 'getRealtimeMetrics', vehicleId];
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.ids)
        params.append('ids', props.ids.join(','));
    if (props.missionId)
        params.append('missionId', props.missionId);
    if (props.ownerId)
        params.append('ownerId', props.ownerId);
    if (props.includeInactivated)
        params.append('includeInactivated', props.includeInactivated.toString());
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return props ? [CacheKey, 'list', props] : [CacheKey, 'list'];
}
async function update(csrfToken, vehicleId, props) {
    const form = new FormData();
    form.append('vehicleId', vehicleId);
    if (props.vehicleType)
        form.append('vehicleType', props.vehicleType);
    if (props.email)
        form.append('email', props.email);
    if (props.groupIds)
        props.groupIds.forEach((e) => form.append('groupIds', e));
    if (props.name)
        form.append('name', props.name);
    if (props.serialNumber)
        form.append('serialNumber', props.serialNumber);
    if (props.image)
        form.append('image', props.image.blob, props.image.filename);
    if (props.deleteImage !== undefined)
        form.append('deleteImage', String(props.deleteImage));
    if (props.cameraCodec)
        form.append('cameraCodec', props.cameraCodec);
    if (props.cameraResolution)
        form.append('cameraResolution', props.cameraResolution);
    return (await (await SecureAxios()).put(PATHS.UPDATE(vehicleId), form, {
        headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' },
    })).data;
}
export default {
    CacheKey,
    command,
    confirmActivation,
    create,
    deactivate,
    delete_,
    get,
    getKey,
    getLastGeometrics,
    getLastGeometricsKey,
    getLastMetrics,
    getLastMetricsKey,
    getRealtimeGeometrics,
    getRealtimeGeometricsKey,
    getRealtimeMetrics,
    getRealtimeMetricsKey,
    list,
    listKey,
    update,
};
